<template>
    <div :class="quillClass" >
      <quill-editor
        :content="content"
        ref="mhQuillEditor"
        :options="editorOption"
        @ready="onEditorReady($event)"
        @focus="onEditorFocus($event)"
        @blur="onEditorBlur($event)"
        @change="onEditorChange($event)"
        class="editor_quill"
      ></quill-editor>
      <form action method="post" enctype="multipart/form-data" id="uploadFormMulti">
        <input
          style="display: none"
          :id="uniqueId"
          type="file"
          name="file"
          multiple
          accept="image/jpg, image/jpeg, image/png, image/gif"
          @change="uploadImg()"
        />
      </form>
      <div id="toolbar_hidden"></div>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
// eslint-disable-next-line no-undef
Quill.register('modules/imageDrop', ImageDrop)
// eslint-disable-next-line no-undef
Quill.register('modules/imageResize', ImageResize)

// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  // ['blockquote', 'code-block'], // 引用  代码块-----['blockquote', 'code-block']
  // [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  // [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [{ script: 'sub' }, { script: 'super' }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [{ indent: '-1' }, { indent: '+1' }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  // [{ direction: 'rtl' }], // 文本方向-----[{'direction': 'rtl'}]
  [{ size: ['small', false, 'large', 'huge'] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ font: [] }], // 字体种类-----[{ font: [] }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  ['clean'], // 清除文本格式-----['clean']
  ['image'] // 链接、图片、视频-----['link', 'image', 'video']
]

export default {
  components: {
    quillEditor
  },
  name: 'MhQuillEditor',
  props: ['mObj', 'mProp', 'fileProps', 'editdisable'],
  data () {
    return {
      uniqueId: 'uniqueId',
      content: '',
      flag: false,
      f: false,
      quillClass: 'toolbar_hidden',
      editorOption: {
        //  富文本编辑器配置
        modules: {
          imageDrop: true,
          imageResize: {
            displaySize: true
          },
          // 工具栏定义的
          toolbar: toolbarOptions
        },
        // 主题
        theme: 'snow',
        placeholder: this.$t('base.MhQuillEditor.pleaseEnterText')
      }
    }
  },
  computed: {
    // 当前富文本实例
    editor () {
      return this.$refs.mhQuillEditor.quill
    },
    filePropsObj () {
      return JSON.parse(this.fileProps)
    },
    readOnly () {
      console.log(this.f) // 勿删
      return this.editdisable || this.filePropsObj.readOnly
    },
    quillHeight () {
      return this.filePropsObj.height || 0
    }
  },
  methods: {
    // 准备富文本编辑器
    onEditorReady (quill) {},
    // 富文本编辑器 失去焦点事件
    onEditorBlur (quill) {},
    // 富文本编辑器 获得焦点事件
    onEditorFocus (quill) {},
    // 富文本编辑器 内容改变事件
    onEditorChange (quill) {
      const that = this
      that.content = quill.html
      if (that.content !== that.mObj[that.mProp]) {
        that.$parent.$Any.updateObjProp(that.mObj, that.mProp, that.content)
      }
    },
    uploadImg: async function (file) {
      var that = this
      const nbr = that.mObj[that.filePropsObj.efileNbr]
      let lot = ''
      if (that.filePropsObj.efileLot !== '') {
        lot = that.mObj[that.filePropsObj.efileLot]
      }
      var formData = new FormData()
      formData.append('nbr', nbr)
      formData.append('lot', lot)
      if (file) {
        formData.append('file', file)
      } else {
        formData.append('file', document.getElementById(that.uniqueId).files[0])
      }

      const { data: res } = await this.$http.post('/edoc/uploadImageFile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const flag = res.data.flag
      const msg = res.data.msg
      if (flag !== -1) {
        document.getElementById(that.uniqueId).value = ''
        that.$alert(msg, this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm')
        })
      } else {
        const url = res.data.returnUrl
        // url = url.indexOf('http') !== -1 ? url : 'http:' + url
        const Range = that.editor.getSelection()
        that.editor.insertEmbed(
          Range != null ? Range.index : 0,
          'image',
          url
        )
        document.getElementById(that.uniqueId).value = ''
      }
    }
  },
  mounted () {
    var that = this
    that.uniqueId = that.$Any.randomString()
    var imgHandler = async function (image) {
      if (image) {
        var fileInput = document.getElementById(that.uniqueId) // 隐藏的file文本ID
        fileInput.click() // 加一个触发事件
      }
    }
    that.content = that.mObj[that.mProp]
    that.editor.getModule('toolbar').addHandler('image', imgHandler)
    that.$forceUpdate()
    that.editor.root.addEventListener('paste', evt => {
      if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
        evt.preventDefault();
        [].forEach.call(evt.clipboardData.files, file => {
          if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
            return
          }
          that.uploadImg(file)
        })
      }
    }, false)

    if (that.readOnly) {
      that.editor.disable()
      that.quillClass = 'toolbar_hidden'
    } else {
      that.editor.enable()
      that.quillClass = ''
    }
    if (that.quillHeight > 0) {
      that.editor.container.style.height = `${that.quillHeight}px`
    }
  },
  watch: {
    mObj: {
      handler (newObj, oldObj) {
        const that = this
        that.flag = true
        that.content = that.mObj[that.mProp]
      },
      deep: true
    },
    editdisable (newObj, oldObj) {
      const that = this
      that.f = !that.f
      console.log('this.readOnly', that.readOnly)
      if (that.readOnly) {
        that.editor.disable()
        that.quillClass = 'toolbar_hidden'
      } else {
        that.editor.enable()
        that.quillClass = ''
      }
    }
  }
}
</script>

<style lang="less" >
.toolbar_hidden {
  .ql-toolbar.ql-snow {
    display: none;
  }
}
.editor_quill {
 line-height: normal !important;
}
.ql-editor{
  min-height: 80px;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>
